import React, { Component } from "react";

import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import { connect } from "react-redux";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CustomInput from "components/CustomInput/CustomInput.jsx";
import Button from "components/CustomButtons/Button.jsx";
import NavPills from "components/NavPills/NavPills.jsx";
import CustomLinearProgress from "components/CustomLinearProgress/CustomLinearProgress.jsx";
import { withStyles } from "@material-ui/core/styles";

import SearchTab from "../../granular/Leftpanel/search";
import Tracking from "../../granular/Leftpanel/tracking";
import Zonatracking from "../../granular/Leftpanel/zonatracking";
import ChangeDest from "../../granular/Leftpanel/changedest";
import Jumping from "../../granular/Leftpanel/jump";
import Draugh from "../../granular/Leftpanel/draugh";
import Speed from "../../granular/Leftpanel/speed";
import IncompleteInfo from "../../granular/Leftpanel/incompleteinfo";
import Inactive from "../../granular/Leftpanel/inactive";
import IdleClose from "../../granular/Leftpanel/idleclose";

const styles = theme => ({
  title: {
    textAlign: "center",
    flex: 1,
    fontSize: "32px",
    fontWeight: 500
  }
});

class Search extends Component {
  constructor(props) {
    super(props);
    this.state = {
      search: this.props.searchnya
    };
  }

  UNSAFE_componentWillMount() {
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    console.log(nextProps);
  }

  render() {
    const { classes } = this.props;
    return (
      <GridContainer>

        <Grid item xs={12}>
          <Grid container justify="center" spacing={2}>
            <GridItem xs={12} sm={12} md={12}>
              <div style={{ justifyContent: "center" }}>

                <CustomLinearProgress
                  variant="determinate"
                  color="gray"
                  value={0}
                  style={{ width: "50%", display: "inline-block" }}
                />
                <CustomLinearProgress
                  variant="determinate"
                  color="gray"
                  value={0}
                  style={{ width: "50%", display: "inline-block" }}
                />
              </div>
            </GridItem>
            <GridItem xs={10} sm={10} md={10} style = {{paddingTop:10}}>
                        <SearchTab search = {this.state.search}/>
            </GridItem>
          </Grid>
        </Grid>
      </GridContainer>
    );
  }
}

function mapStateToProps(state) {
  return {
    token: state.token,
    searchVessel:state.searchVessel,
    blocking: state.loader,
    rightPanel: state.rightPanel,
    leftPanel: state.leftPanel,
    sourceAis: state.sourceAis,
  };
}

export default connect(
  mapStateToProps,
  {  }
)(withStyles(styles)(Search));
